import {EventBus} from "../events/EventBus";
import GoogleTracking from "./tracking/GoogleTracking";
import {WhitelabelEvent, WhitelabelEventWithPayload} from "../events/Events";
import GA4Tracking from "./tracking/GA4Tracking";
import http from "./http";
import {SECTION_CLICKED_EVENT_TYPE, FILTERS_MODAL_OPENED_EVENT_TYPE, SEARCH_SAVED_EVENT_TYPE} from "../tracking/constants";

let tracker: GoogleTracking | object;

let eventBus: EventBus;

interface TrackAnalyticsEventPayload {
    name: string | undefined,
}

interface TrackAmplitudeEventPayload {
    type: string,
    serpUrl: string,
    section?: string,
    pageViewId?: string,
    filters?: {},
    sectionName?: string,
    value?: string,
}

class TrackAnalyticsEvent implements WhitelabelEventWithPayload<TrackAnalyticsEventPayload> {
    payload: TrackAnalyticsEventPayload;
    type: string;
    static readonly TYPE: string = 'tracking-track-event';

    constructor(payload: TrackAnalyticsEventPayload) {
        this.type = TrackAnalyticsEvent.TYPE;
        this.payload = payload;
    }
}

class TrackAmplitudeEvent implements WhitelabelEventWithPayload<TrackAmplitudeEventPayload> {
    payload: TrackAmplitudeEventPayload;
    type: string;
    static readonly TYPE: string = 'tracking-amplitude-event';

    constructor(payload: TrackAmplitudeEventPayload) {
        this.type = TrackAmplitudeEvent.TYPE;
        this.payload = payload;
    }
}

function getAmplitudeEventBody(payload: TrackAmplitudeEventPayload) {
    if (payload.type === SEARCH_SAVED_EVENT_TYPE) {
        return {
            section: payload.section,
            eventType: payload.type,
            serpUrl: payload.serpUrl,
        };
    }

    if (payload.type === FILTERS_MODAL_OPENED_EVENT_TYPE) {
        return {
            eventType: payload.type,
            serpUrl: payload.serpUrl,
        };
    }

    if (payload.type === "FiltersUpdated") {
        return {
            eventType: payload.type,
            serpUrl: payload.serpUrl,
            ...payload.filters,
        }
    }

    if (payload.type === SECTION_CLICKED_EVENT_TYPE) {
        return {
            eventType: payload.type,
            serpUrl: payload.serpUrl,
            sectionName: payload.sectionName,
            value: payload.value,
            sectionId: payload.section,
        };
    }

    return {}
}

export function trackAmplitudeEventHandler(event: WhitelabelEvent) {
    const { payload} = event as TrackAmplitudeEvent;

    if (payload.type === "SearchSaved" && payload.section == null) {
        return;
    }

    eventBus.emit(new http.PostEvent({
        url: '/api/tracking/track',
        body: getAmplitudeEventBody(payload),
    }));
}

export function trackAnalyticsEventHandler(event: WhitelabelEvent) {
    const { payload: { name }} = event as TrackAnalyticsEvent;
    if (name == null) {
        return;
    }

    (tracker as GoogleTracking).trackEvent(name);
}

function init(tr: GoogleTracking | object = GA4Tracking, ev: any = EventBus.getInstance()) {
    tracker = tr;
    eventBus = ev;
    eventBus.subscribe(TrackAnalyticsEvent.TYPE, trackAnalyticsEventHandler);
    eventBus.subscribe(TrackAmplitudeEvent.TYPE, trackAmplitudeEventHandler);
}

export default {
    TrackAnalyticsEvent,
    TrackAmplitudeEvent,
    init,
}